<div [innerHTML]="template" #externalMenuElement></div>